var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-submit" }, [
    _c(
      "div",
      { staticClass: "form-submit--wrap" },
      [
        _c(
          _vm.recaptchaComponent.is,
          _vm._b(
            {
              ref: "recaptcha",
              tag: "component",
              on: {
                render: function($event) {
                  _vm.onRecaptchaRendered($event)
                },
                expired: function($event) {
                  _vm.onRecaptchaExpired($event)
                },
                verify: function($event) {
                  _vm.onRecaptchaVerified($event)
                }
              }
            },
            "component",
            _vm.recaptchaComponent,
            false
          ),
          [
            _c(
              "loader-btn",
              {
                staticClass: "form-submit--btn",
                attrs: {
                  type: "submit",
                  "btn-facets": _vm.btnFacets,
                  "is-loading": _vm.isLoading
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.onVerify($event)
                  }
                }
              },
              [
                _c("span", { staticClass: "btn--wrap" }, [
                  _c("span", { staticClass: "btn--text" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.label) +
                        "\n                    "
                    )
                  ])
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-426f81e2", { render: render, staticRenderFns: staticRenderFns })
  }
}